import React, { Component } from 'react';
import ActionButton from '../../common/ActionButton';
import { getErrorMessages } from '../../../utils';
import { ErrorMessage } from '../../common';
import { executeHttpRequest } from '../../../epics/api';
import LoadingSpinner from '../../common/LoadingSpinner';
import { TPageNotification } from '../../../types';


type ConfirmDeleteAvailabilityListProps = {
    currentUrlParams: URLSearchParams;
    notification: TPageNotification;
    onActionSuccess: () => void;
    closeModal: () => void;
    reloadData: () => void;
    availabilityLists: { label: string, value: string | number }[];
}

type ConfirmDeleteAvailabilityListState = {
    isLoading: boolean;
    error: string;
    selectedList: number;
}

export class ConfirmDeleteAvailabilityList extends Component<
    ConfirmDeleteAvailabilityListProps,
    ConfirmDeleteAvailabilityListState
> {
    constructor(props: ConfirmDeleteAvailabilityListProps) {
        super(props);

        const _selectedList = props.currentUrlParams.get('availability_lists');
        this.state = {
            isLoading: false,
            error: null,
            selectedList: _selectedList ? Number(_selectedList) : null,
        };
    }

    getListName = (id: number) => {
        const matchedList = this.props.availabilityLists.find(item => item.value === id);
        return matchedList ? matchedList.label : null;
    }

    deleteAvailabilityList = ()=> {
        this.setState({ isLoading: true });

        executeHttpRequest(
            `availability-lists/${this.state.selectedList}/`,
            'delete',
        ).then(() => {
            this.setState({ isLoading: false });
            const currentListName = this.getListName(this.state.selectedList);
            const successMessage = `"${currentListName}" list has been deleted successfully.`;
            this.props.notification.success('Success', successMessage);
            this.props.closeModal();
            if (this.props.onActionSuccess) {
                this.props.onActionSuccess();
            }
        }).catch(error => {
            this.setState({
                error: getErrorMessages(error),
                isLoading: false,
            });
        });
        };

    render() {
        const listName = this.getListName(this.state.selectedList);

        return (
            <div className="cancel-shift">
                <div className="popup-header">
                    <h1>
                        Delete Availability List
                    </h1>
                </div>
                <div>
                    Are you sure you want to delete <q><strong>{listName}</strong></q> list?
                </div>
                <div className="modal-bottom-bar">
                    <ActionButton
                        onAction={this.deleteAvailabilityList}
                        text={this.state.isLoading
                            ? (
                                <LoadingSpinner
                                    className="mass-booking-spinner"
                                    backgroundColor="white"
                                />
                            ) : (
                                'CONFIRM'
                            )
                        }
                        className="confirm"
                    />
                    <ActionButton
                        onAction={this.props.closeModal}
                        text="Cancel"
                        className="cancel"
                    />
                </div>
                {this.state.error ? (
                    <ErrorMessage message={this.state.error} />
                ) : false}
            </div>
        );
    }
}
